import { render, staticRenderFns } from "./MyAssets.vue?vue&type=template&id=f303fa76"
import script from "./MyAssets.vue?vue&type=script&lang=js"
export * from "./MyAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports